import getApi from '../../api/apisauceConfig'
import { PatientAlert } from '../../model/HealthData'

export const getPatientAlerts = (patientId: number) =>
  getApi().get<Array<PatientAlert>>(`patients/${patientId}/alerts`)
